<template>
    <div class="wf-picker">
        <div class="wf-picker-label">{{label}}</div>
        <div class="wf-picker-input">
            <input type="text" readonly v-model="componentText" @click="handleShow" :placeholder="placeholder">

            <div class="wf-picker-icon">
                <img :class="`${isShow ? 'wf-picker-icon-up' : ''}`"  src="../image/rangePicker/wap_open.png" alt="">
            </div>
        </div>

		<Popup v-model="isShow" position="bottom">
			<Picker :value-key="valueKey" show-toolbar :columns="options" :default-index="defaultIndex" v-model="componentValue" @confirm="handleConfirm"></Picker>
		</Popup>
    </div>
</template>

<script>
import Picker from 'vant/lib/picker'
import Popup from 'vant/lib/popup'
import 'vant/lib/picker/style';
import 'vant/lib/popup/style'

export default {
	components: {
		Picker,
		Popup
    },
	props: {
		value: {
			type: String | Number,
			default: ""
		},
        label: {
            type: String,
            default: ""
        },
        options: {
            type: Array,
            default: () => {
                return []
            }
		},
		placeholder: {
			type: String,
			default: '请选择'
		},
		valueKey: {
			type: String,
			default: 'text'
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
    data() {
		return {
			isShow: false,
			defaultIndex: 0
        }
	},
	mounted() {
		for (let i = 0; i < this.options.length; i++) {
			if (this.options[i].value === this.value) {
				this.defaultIndex = i
			}
		}
	},
	computed: {
		componentValue() {
			return this.value
		},

		componentText() {
			for (let i = 0; i < this.options.length; i++) {
				if (this.options[i].value === this.value) {
					return this.options[i][this.valueKey]
				}
			}
		}
	},
	methods: {
		// 处理点击选择器
		handleShow() {
			this.isShow = true
		},

		// 处理确认事件
		handleConfirm(event) {
			this.$emit('change', event.value)
			this.isShow = false
		}
	}
}
</script>

<style lang="scss" scoped>
.wf-picker {
    display: flex;
    flex-direction: row;
    align-items: center;
    .wf-picker-label {
        //width: 1.04rem;
        text-align: right;
        font-size: 0.26rem;
        color: #666;
    }
    .wf-picker-input {
		position: relative;
        width: 1.9rem;
        height: 0.6rem;
        margin-left: 0.16rem;
        border: 0.02rem solid #e0e0e0;
        > input {
            display: block;
            width: 100%;
            height: 100%;
			padding-left: 0.16rem;
			font-size: 0.26rem;
			//line-height: 0.54rem;
            border: none;
            outline: none;
        }
		input::-webkit-input-placeholder {
            color: #ccc;
        }
        input::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #ccc;
        }
        input:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #ccc;
        }
        input:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: #ccc;
        }
		.wf-picker-icon {
			position: absolute;
			width: 0.13rem;
			height: 0.08rem;
			top: 0;
			bottom: 0;
			right: 0.21rem;
			margin: auto;
			>img {
				display: block;
				width: 100%;
				height: 100%;
				transition: transform .15s;
			}
			.wf-picker-icon-up {
				transform: rotate(180deg);
			}
		}
    }
}
</style>


// WEBPACK FOOTER //
// src/components/picker/picker.vue